// copied from charisma-aws-webservice
// TODO add shared types and utils to a shared library called by both front and backend
// TODO add the above to Jira backlog

import { partial } from "lodash";

type ObjectIndex= keyof object;

export const getOne: any = (partialObj: object, tag: string) => {
  let propIndex;
  if (tag.includes('[')) {
    try {
      propIndex = JSON.parse(tag)[0];
    }
    catch {
      propIndex = tag;
    }
  }
  else {
    propIndex = tag;
  }
  return partialObj[propIndex as ObjectIndex];
}

export const getIn = (obj: object, tags: string[]) => {
  try {
    return tags.reduce(getOne, obj);
  }
  catch {
    throw new Error('Malformed tags argument. Array indexes must be in form \"[n]\" for index n. Object keys must be strings.');
  }
}

export const concatTag = (jsonPath: string, tag: string) => {
  if (tag.includes('[')) {
    return jsonPath + tag;
  }
  else {
    return jsonPath + '.' + tag;
  }
}

export const getJsonPath = (tags: string[]) => {
  if (!tags || !Array.isArray(tags)) {
    throw new Error('Malformed tags argument. Tags must be an array of object accessors. Array indexes must be in form \"[n]\" for index n. Object keys must be strings.');
  }
  else {
    return tags.map(tag => tag.toString())?.reduce(concatTag, "$");
  }
}

export const mergeNestedValue = (currentValue: object, updateObject: object) => {
  // TODO rewrite this to leverage polymorphism in typescript instead of a switch statement
  let mergedValue;
  if (currentValue && Array.isArray(currentValue)){
    mergedValue = [...currentValue, updateObject];
  }
  else if (typeof currentValue == 'object') {
    mergedValue = {...currentValue, ...updateObject};
  }
  else {
    throw new Error(`Object at specified path is not a valid object to update`);
  }
  return mergedValue;
}
